/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import IconProps, { StyledG } from './IconProps';

function StarIconClosed(props: IconProps) {
	const { color = 'yellow' } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
				<StyledG color={color} fillRule="nonzero" transform="translate(-301 -523)">
					<path d="M307.875 529.87542L301 530.50043 306.18875 535.733949 304.75 543 310.978125 539.204003 317.20125 543 315.804688 535.728636 321 530.50043 314.125 529.87542 311 523z" />
				</StyledG>
			</g>
		</svg>
	);
}

export default StarIconClosed;
